import { EmpresaUsuario } from '../../modulos/main/objetos/empresa';
import { Usuario } from '../../modulos/main/objetos/usuario';
export class EmpresaClases {
  /**
   * Lee el usuario de localStorage sin lanzar cuando no hay sesión.
   * `getItem` devuelve null si la key no existe, y `JSON.parse('')` truena con
   * "Unexpected end of JSON input"; sin sesión (antes del login, tras logout o
   * tras cualquier localStorage.clear()) eso reventaba a los guards.
   */
  private static leerUsuarioLocal = (): Usuario => {
    const crudo = localStorage.getItem('user');
    if (!crudo) return {} as Usuario;
    try {
      return (JSON.parse(crudo) ?? {}) as Usuario;
    } catch {
      return {} as Usuario;
    }
  };

  /**
   * Obtener las empresas asignadas del usuario almacenadas de manera local
   * @param seleccionadas - boolean - (OPCIONAL) TRUE si es recupera del objeto empresasSeleccionadas, FALSE o sin parametro si recupera del objeto empresasUsuario
   * @returns EmpresaUsuario[] - Array de empresas asignadas
   */
  static obtenerEmpresasAsignadas = (
    seleccionadas: boolean = false
  ): EmpresaUsuario[] => {
    let empresas: EmpresaUsuario[] = [];
    try {
      const usuario: Usuario = this.leerUsuarioLocal();

      const EMPRESAS_USUARIO = seleccionadas
        ? usuario?.empresasSeleccionadas
        : usuario?.empresasUsuario;

      empresas =
        EMPRESAS_USUARIO?.map((res: EmpresaUsuario | any) => {
          return {
            empresaIdSeleccionada: res?.empresaIdSeleccionada || 0,
            id: res?.id || res?.empresaId,
            nombre: res?.nombreComercial || '',
            empresaId: res?.empresaId || res?.id || 0,
            limiteFondoCaja: res?.limiteFondoCaja || 0,
            nombreComercial: res?.nombreComercial || '',
            promocionesId: res?.promocionesId || 0,
            sucursalIdMicrosip: res?.sucursalIdMicrosip || 0,
            dns: res?.dns || '',
            urlFacturas: res?.urlFacturas || '',
            ticketDigital: res?.ticketDigital || false,
            qr_satisfaccion: res?.qr_satisfaccion || '',
            qr_facturacion: res?.qr_facturacion || '',
            onix: res?.onix || false,
            esAeropuerto: res?.esAeropuerto || false,
            esCruzRoja: res?.esCruzRoja || false,
            cedis: res?.cedis || false,
            ...res,
          } as EmpresaUsuario;
        }) || [];

      if (empresas.length == 0 && !seleccionadas) {
        console.log('ESTE USUARIO NO TIENE EMPRESAS ASIGNADAS');
      } else {
        empresas.unshift({
          empresaIdSeleccionada: 0,
          id: 0,
          nombre: 'Todas las empresas',
          empresaId: 0,
          limiteFondoCaja: 0,
          nombreComercial: '',
          promocionesId: 0,
          sucursalIdMicrosip: 0,
          dns: '',
          urlFacturas: '',
          ticketDigital: false,
          qr_satisfaccion: '',
          qr_facturacion: '',
          onix: false,
          esAeropuerto: false,
          esCruzRoja: false,
          cedis: false,
        } as EmpresaUsuario);
      }
    } catch (error) {
      console.error('Error al obtener las empresas asignadas: ', error);
      throw error;
    }
    return empresas;
  };

  /**
   * Obtiene las empresas asignadas del usuario almacenadas de manera local, filtradas por id
   * @returns EmpresaUsuario[] - Array de empresas asignadas
   */
  static obtenerEmpresasAsignadasConId(): EmpresaUsuario[] {
    const EMPRESAS : EmpresaUsuario[] = this.obtenerEmpresasAsignadas(false).filter(
      (empresa: EmpresaUsuario) => empresa.empresaId !== 0
    );
    return EMPRESAS;
  }

  /**
   * Obtener las empresas seleccionadas del usuario almacenadas de manera local
   * @returns EmpresaUsuario[] - Array de empresas seleccionadas del usuario, almacenadas de manera local
   */

  static obtenerEmpresasSeleccionadas = (): EmpresaUsuario[] => {
    return this.obtenerEmpresasAsignadas(true).filter(
      (empresa: EmpresaUsuario) => empresa.empresaId !== 0
    );
  };
}
